module.exports = __webpack_public_path__ + "img/info.5d663524.svg";